"use client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "../lib/redux/store";
import Loader from "@/components/Loader";

interface PersistantProviderProps {
  children: React.ReactNode;
}

const PersistantProvider: React.FC<PersistantProviderProps> = ({
  children,
}) => {
  return (
    <Provider store={store}>
      {/* <PersistGate
        // loading={
        //   <div className="w-4 h-4 border-4 border-t-4 border-gray-500 border-t-blue-500 rounded-full animate-spin"></div>
        // }
        persistor={persistor}
      > */}
      {children}
      {/* </PersistGate> */}
    </Provider>
  );
};

export default PersistantProvider;
